import * as colors from "../styles/colors";
import { node, string, bool, object } from "prop-types";
import React from "react";
import { StyleSheet, css } from "aphrodite/no-important";

const paperStyleSheet = StyleSheet.create({
	container: {
		backgroundColor: colors.white,
		boxShadow: `${colors.transparentBlack6} 0px 1px 6px, ${
			colors.transparentBlack6
		} 0px 1px 4px`,
		color: colors.textDarkGrey3,
	},
	rounded: {
		borderRadius: 2,
	},
});

export const paperProps = {
	children: node,
	className: string,
	rounded: bool,
	style: object,
};

export const Paper = ({ children, className, rounded = true, style }) => {
	const finalClassName = className
		? `${css(paperStyleSheet.container, rounded ? paperStyleSheet.rounded : null)} ${className}`
		: css(paperStyleSheet.container, rounded ? paperStyleSheet.rounded : null);

	return (
		<div className={finalClassName} style={style}>
			{children}
		</div>
	);
};

Paper.propTypes = paperProps;
